import React from "react";
import TransactionModal from "./TransactionModal";
import CloseIcon from "../../../assets/svgs/closeIcon.svg";
import ReportProblemOutlinedIcon from "@material-ui/icons/ReportProblemOutlined";
import useStyles from "./transactionModalStyles";

function TransactionError({ transactionError, setTransactionError }) {
  const classes = useStyles();
  return (
    <div>
      <TransactionModal
        open={transactionError}
        height={"300px"}
        width={"325px"}
      >
        <div>
          <div>
            <img
              src={CloseIcon}
              // style={{
              //   display: "flex",
              //   marginLeft: "auto",
              //   fontWeight: "500",
              //   // transform: "scale(1.4)",
              //   cursor: "pointer",
              //   marginTop: "10px",
              // }}
              className={classes.closeIcon}
              onClick={() => {
                setTransactionError(false);
              }}
            />
          </div>
          <div style={{ color: "#282828", textAlign: "center" }}>
            <div style={{ padding: "30px", textAlign: "-webkit-center" , display:"flex", justifyContent:"center"}}>
              <div
                style={{
                  display: "flex",
                  borderRadius: "50%",
                  justifyContent: "center",
                  background: "#FFDF00",
                  padding: "18px",
                  width: "fit-content",
                  filter:"drop-shadow( 3px 3px 20px rgba(255, 223, 0, 0.7))"
                }}
              >
                <ReportProblemOutlinedIcon
                  style={{
                    color: "#282828",
                    fontWeight: "900",
                    fontSize: "60px",
                  }}
                />
              </div>
            </div>
            <div
              style={{
                fontStyle: "normal",
                fontWeight: "800",
                fontSize: "20px",
                lineHeight: "25px",
                color: "#282828",
              }}
            >
              Transaction Failed
            </div>
            <div
              style={{
                paddingTop: "20px",
                fontFamily: "Inter",
                fontStyle: "normal",
                fontWeight: "500",
                fontSize: "16px",
                lineHeight: "140%",
                /* or 22px */

                textAlign: "center",

                color: "#696969",
              }}
            >
              The transaction cannot succeed due to error. This is probably an
              issue with one of the token you are swapping.
            </div>
          </div>
        </div>
      </TransactionModal>
    </div>
  );
}

export default TransactionError;
